module.exports = __webpack_public_path__ + "static/media/AvenirNext-Regular.d3e6f14a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-Regular.eot?#iefix
// module id = 79
// module chunks = 0